<template>
  <el-form ref="accountForm" :model="storeInfo" :rules="rules" :disabled="!canEdit" label-width="120px" class="el-form-flex">
    <template v-if="storeInfo && storeInfo.detail">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="el-form-content">
            <el-form-item label="账户类型">
              <el-radio-group v-model="storeInfo.detail.accountType" size="small" class="max-width" @input="onChange">
                <el-radio-button :label="1">对公账户</el-radio-button>
                <el-radio-button :label="2">对私账户</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="10">
          <div class="el-form-content">
            <el-form-item label="开户银行" prop="detail.bankOfDeposit">
              <el-input v-model.trim="storeInfo.detail.bankOfDeposit" placeholder="请输入开户银行" @blur="onChange" />
            </el-form-item>
            <el-form-item label="结算账户名" prop="detail.bankAccountName">
              <el-input v-model.trim="storeInfo.detail.bankAccountName" placeholder="请输入结算账户名" @blur="onChange" />
            </el-form-item>
            <el-form-item label="结算账号" prop="detail.bankNumber">
              <el-input v-model.trim="storeInfo.detail.bankNumber" placeholder="请输入结算账号（银行卡号）" @blur="onChange" />
            </el-form-item>
          </div>
        </el-col>
        <el-col v-if="storeInfo.detail.accountType === 2" :sm="24" :md="12" :lg="{span: 10, offset: 4}">
          <div class="el-form-content">
            <el-form-item label="身份证号码" prop="detail.bankIdCard">
              <el-input v-model.trim="storeInfo.detail.bankIdCard" placeholder="请输入结算人身份证号码" @blur="onChange" />
            </el-form-item>
            <el-form-item label="银行预留手机号" prop="detail.bankPhone">
              <el-input v-model.trim="storeInfo.detail.bankPhone" type="number" :maxlength="11" placeholder="请输入11位手机号码" @blur="onChange" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </template>
  </el-form>
</template>

<script>
export default {
  name: 'ShopAccount',
  props: {
    canEdit: Boolean,
    value: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      storeInfo: {}
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newInfo) {
        this.storeInfo = { ...newInfo }
      }
    }
  },
  mounted() {
    this.storeInfo = { ...this.value }
  },
  methods: {
    onChange() {
      this.$emit('input', this.storeInfo)
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.accountForm.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject('校验失败')
          }
        })
      })
    },
    reset() {
      this.$refs.accountForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-group {
  display: inline-flex;
  align-items: center;
  .el-radio {
    flex: 1;
  }
}
</style>
